import {
  FULL_STANDARD_DATE_TIME_FORMAT_DATE_FNS,
  STANDARD_DATE_FORMAT_DATE_FNS,
  STANDARD_DATE_TIME_FORMAT_DATE_FNS,
} from '@savgroup-front-common/constants';
import { ResultSearchType } from '@savgroup-front-common/core/molecules/SearchWithDimmer/SearchWithDimmer.types';
import { tryToParse } from '@savgroup-front-common/core/helpers';
import { RESULT_TYPE } from '@savgroup-front-common/types/Search';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

import { TABS_FILE } from '../../../constants/routing';
import {
  buildFilesUrl,
  buildOrdersUrl,
  buildStockItemsUrl,
} from '../../../helpers';

import messages from './messages';
import { EmptyResponse, SearchResultGroup } from './Search/Search.types';

export const adaptSearchResults = ({
  response,
  primaryColor,
  cautionColor,
  successColor,
}: {
  response: SearchResultGroup | EmptyResponse;
  primaryColor: { color: string; bgColor: string };
  cautionColor: { color: string; bgColor: string };
  successColor: { color: string; bgColor: string };
}): SearchResultList<ResultSearchType>[] => {
  const resultSearched: SearchResultList<ResultSearchType>[] = [];

  if (response.file.hitCount) {
    resultSearched.push({
      rubrics: [],
      sortableProperties: [],
      hits: response.file.hit?.map((hit) => ({
        searchId: hit.fileId,
        searchReference: hit.fileReference,
        searchLocalizedInfo: hit.statusId?.at(0),
        searchFirstName: hit.ownerFirstName,
        searchLastName: hit.ownerLastName,
        searchUrl: buildFilesUrl({
          fileId: hit.fileId,
          fileTabId: TABS_FILE.SUMMARY,
        }),
        highlights: hit.highlights,
      })) ?? [],
      hitCount: response.file.hitCount,
      title: messages.files,
      icon: 'Folder',
      iconColor: primaryColor,
      type: RESULT_TYPE.FILE,
    });
  }

  if (response.order.hitCount) {
    resultSearched.push({
      rubrics: [],
      sortableProperties: [],
      hits: response.order.hit?.map((hit) => ({
        searchId: hit.orderId,
        searchReference: hit.orderReference,
        searchLocalizedInfo: hit.sellerName,
        searchFirstName: hit.firstName,
        searchLastName: hit.lastName,
        searchUrl: buildOrdersUrl({ orderId: hit.orderId }),
        purchaseDate: tryToParse({
          value: hit.purchaseDate,
          patterns: [
            STANDARD_DATE_FORMAT_DATE_FNS,
            STANDARD_DATE_TIME_FORMAT_DATE_FNS,
            FULL_STANDARD_DATE_TIME_FORMAT_DATE_FNS,
          ],
        })?.value,
      })) ?? [],
      hitCount: response.order.hitCount,
      title: messages.order,
      icon: 'Order',
      iconColor: cautionColor,
      type: RESULT_TYPE.ORDER,
    });
  }

  if (response.stockItem.hitCount) {
    resultSearched.push({
      rubrics: [],
      sortableProperties: [],
      hits: response.stockItem.hit?.map((hit) => ({
        searchId: hit.requestLineId,
        searchReference: hit.fileReference,
        searchLocalizedInfo: hit.sparePartReference,
        searchFirstName: hit.stockName,
        searchLastName: hit.supplierName,
        searchUrl: buildStockItemsUrl({
          searchQuery: hit.sparePartReference,
        }),
      })) ?? [],
      hitCount: response.stockItem.hitCount,
      title: messages.stockItem,
      icon: 'Stock',
      iconColor: successColor,
      type: RESULT_TYPE.STOCK_ITEM,
    });
  }

  return resultSearched;
};
